import { render, staticRenderFns } from "./LSTopLeft.vue?vue&type=template&id=3821c28b&scoped=true"
import script from "./LSTopLeft.vue?vue&type=script&lang=js"
export * from "./LSTopLeft.vue?vue&type=script&lang=js"
import style0 from "./LSTopLeft.vue?vue&type=style&index=0&id=3821c28b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821c28b",
  null
  
)

export default component.exports